import React from 'react'
import RealTime from './RealTime'
import { useQueryClient } from '@tanstack/react-query'
import useDebouncedCallback from '@/v2/hooks/useDebouncedCallback'

const RTDay = () => {
  const queryClient = useQueryClient()

  const handleEvent = useDebouncedCallback(() => {
    queryClient.invalidateQueries({
      queryKey: ['DailyCalendar'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['WeeklyCalendar'],
      cancelRefetch: true,
    })
    queryClient.invalidateQueries({
      queryKey: ['NextAppointments'],
      cancelRefetch: true,
    })
  }, 500)

  return <RealTime channel="Calendar::TodayChannel" onEvent={handleEvent} />
}

export default RTDay
